export default __webpack_public_path__ + "static/media/simulate-wasteland-icon.e43d0076.png";